import { createElementFromHtmlContent } from './utils/kameleoon/createElementFromContent';

export default function() {
  window.congstar = window.congstar || {}
  window.congstar.contentLoader = {
    kameleoon:{
      createElementFromHtmlContent
    }
  }
}


